/**
 * Прив’язка полів обліку часу до понять довідника (значок «?» біля підпису поля).
 * Ключ — `time.<сутність>.<поле>`, значення — термін словника (GET /api/v1/kb/glossary).
 * Мапу підключено в features/knowledge/fieldTerms.ts (FIELD_TERMS). Інші ключі `term` у модулі (ставки, бюджети,
 * відсутності, витрати) поки не мають поняття: значок з’явиться, коли довідник прив’яже їх через `fieldKeys`.
 */
export const TIME_FIELD_TERMS: Readonly<Record<string, string>> = {
  // Пороги вартості години (звіт «Вартість години» порівнює з ними справи).
  'time.threshold.value': 'Правило 100 USD',
};
